export const THEME_STORAGE_KEY = "cbcfx-theme";
export const THEME_COOKIE_NAME = "cbcfx-theme";
export const THEME_PREFERENCES = ["system", "light", "dark"];

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function isThemePreference(value) {
  return THEME_PREFERENCES.includes(value);
}

export function readThemeCookie(cookieString = typeof document === "undefined" ? "" : document.cookie) {
  for (const part of cookieString.split(";")) {
    const separator = part.indexOf("=");
    if (separator < 0 || part.slice(0, separator).trim() !== THEME_COOKIE_NAME) continue;
    const rawValue = part.slice(separator + 1).trim();
    try {
      return decodeURIComponent(rawValue);
    } catch {
      return rawValue;
    }
  }
  return null;
}

export function readLocalThemePreference(storage = typeof window === "undefined" ? null : window.localStorage) {
  try {
    const value = storage?.getItem(THEME_STORAGE_KEY);
    return isThemePreference(value) ? value : null;
  } catch {
    return null;
  }
}

export function resolveStoredThemePreference({ cookie, storage } = {}) {
  const cookieValue = readThemeCookie(cookie);
  if (isThemePreference(cookieValue)) return cookieValue;
  return readLocalThemePreference(storage) || "system";
}

export function writeThemeCookie(preference, location = typeof window === "undefined" ? null : window.location) {
  if (typeof document === "undefined" || !isThemePreference(preference)) return;
  const hostname = location?.hostname?.toLowerCase() || "";
  const isCbcfxDomain = hostname === "cbcfx.site" || hostname.endsWith(".cbcfx.site");
  const attributes = [
    `${THEME_COOKIE_NAME}=${encodeURIComponent(preference)}`,
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    "Path=/",
    "SameSite=Lax",
  ];
  if (isCbcfxDomain) attributes.push("Domain=.cbcfx.site", "Secure");
  document.cookie = attributes.join("; ");
}

export function persistThemePreference(preference) {
  if (!isThemePreference(preference)) return;
  writeThemeCookie(preference);
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    // The shared cookie can still preserve the preference when storage is unavailable.
  }
}
